import React from 'react';
import { Link } from 'react-router-dom';

const LinkOverride = props => {
  const { link, externalLink, ...passedProps } = props;
  if (link)
    return (
      <Link
        to={link}
        className={passedProps.className}
        onClick={passedProps.onClick}
        data-type={passedProps.mediaType}
      >
        {props.children}
      </Link>
    );
  if (externalLink)
    return (
      <a
        href={externalLink}
        className={passedProps.className}
        onClick={passedProps.onClick}
        target="_blank"
      >
        {props.children}
      </a>
    );
};

export default LinkOverride;
